export default function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/unsupportedProp/unsupportedProp.js
// module id = 1738
// module chunks = 25